import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../lib/site-data";

export default function FAQ({ items }) {
    const data = items || FAQS;
    return (
        <section className="relative py-24 md:py-32 border-b border-white/5" data-testid="faq-section">
            <div className="max-w-[1000px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                            Sıkça Sorulanlar
                        </p>
                        <h2 className="font-display text-3xl md:text-4xl text-white tracking-tight text-balance">
                            Süreç hakkında merak edilenler
                        </h2>
                    </div>
                    <div className="md:col-span-8">
                        <Accordion type="single" collapsible className="w-full">
                            {data.map((item, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    className="border-b border-white/10"
                                >
                                    <AccordionTrigger
                                        className="text-left text-base md:text-lg text-white hover:text-cyan-300 hover:no-underline py-5"
                                        data-testid={`faq-item-${i}`}
                                    >
                                        {item.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-zinc-400 text-sm leading-relaxed pb-5 pr-4">
                                        {item.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
